'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'parachute-box';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cd';
var svgPathData = ['M50.5 176l79.7 0c5.4-57.4 20.5-108.1 41.7-145-64 24.4-110.3 76.9-121.4 145zm127.9 0l155 0C328.8 131.5 317.8 93 303.6 64.4 283 23.2 263.4 16 256 16s-27 7.2-47.6 48.4c-14.3 28.5-25.2 67-29.9 111.6zM208 384l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM340.1 31c21.2 36.9 36.2 87.6 41.7 145l79.7 0C450.4 107.9 404.1 55.4 340.1 31z', 'M79.5 224l152.5 0 0 96-8 0c-9.3 0-18.1 2-26 5.5L79.5 224zM280 224L432.5 224 314 325.5c-7.9-3.5-16.8-5.5-26-5.5l-8 0 0-96zM8.4 226.2L164.6 360.1c-3 7.4-4.6 15.4-4.6 23.9l0 64c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-64c0-8.4-1.6-16.5-4.6-23.9L503.6 226.2c5.3-4.6 8.4-11.2 8.4-18.2 0-143.5-117.1-240-256-240S0 64.5 0 208c0 7 3.1 13.7 8.4 18.2zM50.5 176c11.1-68.1 57.3-120.6 121.4-145-21.2 36.9-36.2 87.6-41.7 145l-79.7 0zm331.2 0c-5.4-57.4-20.5-108.1-41.7-145 64 24.4 110.3 76.9 121.4 145l-79.7 0zM208.4 64.4C229 23.2 248.6 16 256 16s27 7.2 47.6 48.4c14.3 28.5 25.2 67 29.9 111.6l-155 0c4.7-44.5 15.7-83 29.9-111.6zM224 368l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faParachuteBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;